import { useLocation } from 'react-router-dom';
export const isNextJS = () => {
    if (typeof window !== 'undefined') {
        return Boolean(window.__NEXT_DATA__ || window.next);
    }
    return Boolean(process.env.__NEXT_PROCESSED_ENV ||
        process.env.NEXT_RUNTIME ||
        global.__NEXT_LOADED_PAGES__);
};
export const useGetRoutingType = () => {
    let routingType = 'html';
    try {
        useLocation();
        routingType = 'react-router-dom';
    }
    catch (_a) {
        routingType = 'html';
    }
    if (isNextJS()) {
        routingType = 'nextjs';
    }
    return routingType;
};
//# sourceMappingURL=getRoutingType.js.map